import {
  AppstoreOutlined,
  BankOutlined,
  HomeOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { colors } from "~/styles/tokens";
import { ExploreReveal } from "./ExploreReveal";
import { useExploreInView } from "./useExploreInView";

export function ExploreHierarchySection() {
  const { t } = useTranslation();
  const { ref, isInView } = useExploreInView<HTMLDivElement>({
    threshold: 0.25,
  });

  const layers = [
    {
      key: "org",
      icon: <TeamOutlined />,
      color: colors.actionTertiary,
      label: t("Explore_Hierarchy_Org"),
      body: t("Explore_Hierarchy_Org_Body"),
    },
    {
      key: "property",
      icon: <HomeOutlined />,
      color: colors.actionPrimary,
      label: t("Property"),
      body: t("Explore_Hierarchy_Property_Body"),
    },
    {
      key: "building",
      icon: <BankOutlined />,
      color: colors.statusSuccess,
      label: t("Building"),
      body: t("Explore_Hierarchy_Building_Body"),
    },
    {
      key: "unit",
      icon: <AppstoreOutlined />,
      color: colors.actionSecondary,
      label: t("Unit"),
      body: t("Explore_Hierarchy_Unit_Body"),
    },
  ];

  return (
    <section className="explore-section explore-section--surface-blue">
      <div className="explore-section-inner">
        <ExploreReveal>
          <p className="explore-kicker">{t("Explore_Hierarchy_Kicker")}</p>
          <h2 className="explore-display-title">{t("Explore_Hierarchy_Title")}</h2>
          <p className="explore-lead">{t("Explore_Hierarchy_Lead")}</p>
        </ExploreReveal>

        <div
          ref={ref}
          className={`explore-stack${isInView ? " is-visible" : ""}`}
        >
          <div className="explore-stack-glow" aria-hidden />
          <ol className="explore-stack-layers">
            {layers.map((layer, index) => (
              <li
                key={layer.key}
                className="explore-stack-layer"
                style={{
                  ["--stack-index" as string]: index,
                  ["--stack-color" as string]: layer.color,
                  transitionDelay: isInView
                    ? `${180 + index * 160}ms`
                    : undefined,
                }}
              >
                <div className="explore-stack-layer-shell">
                  <div className="explore-stack-layer-badge" aria-hidden>
                    {layer.icon}
                  </div>
                  <div className="explore-stack-layer-copy">
                    <div className="explore-stack-layer-label">{layer.label}</div>
                    <p className="explore-stack-layer-body">{layer.body}</p>
                  </div>
                  <span className="explore-stack-layer-depth" aria-hidden>
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
